module.exports = __webpack_public_path__ + "static/media/CalculatingIcon.cddc6182.svg";